/**
 * @stable
 */
export enum CashierRouteAction {
    Deposit = 'deposit',
    Withdrawal = 'withdrawal',
    TransactionHistory = 'transactionhistory',
    PaymentPreferences = 'paymentpreferences',
}

export enum DepositType {
    Quick = 'Quick',
    Normal = 'Normal',
}
